import React, { useEffect } from "react";
import { Box, Illustration, Text } from "@mbank-design/design-system/components";
import { WomanHourglassMass } from "@mbank-design/design-system/illustrations";
import { LayoutView, UnorderedListView } from "../../components";
import { DisableBrowserBackButton } from "../../utils";

const texts = [
    "wygeneruj nowy kod QR",
    "zeskanuj go swoim telefonem",
    "zeskanowany kod QR na twoim telefonie pokaż klientowi, aby zeskanował ten kod w swojej aplikacji mObywatel"
];

export const QrCodeInactivePage = (): JSX.Element => {
    useEffect(() => {
        DisableBrowserBackButton();
    }, []);

    return (
        <LayoutView>
            <Box maxWidth={520}>
                <Illustration illustrationComponent={WomanHourglassMass} size="100%"/>
            </Box>
            <Box>
                <Text as="h1" styledAs="h2">kod QR jest nieaktywny</Text>
            </Box>
            <Box>
                <UnorderedListView spacing={16} items={texts} />
            </Box>
        </LayoutView>
    );
}